/*
 * Ofertas (/collections/ofertas): adicionar ao carrinho POR SKU direto do card,
 * sem seletor/modal. Usa o cart-drawer nativo (renderContents) quando existe,
 * com fallback pra /cart. Delegação de evento (cards são renderizados server-side).
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerSections(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addVariant(btn) {
    var card = btn.closest('[data-of-card]');
    if (!card || btn.hasAttribute('disabled')) return;
    var id = card.getAttribute('data-variant-id');
    if (!id) return;

    var label = btn.querySelector('[data-of-add-label]');
    var prev = label ? label.textContent : '';
    var restore = function (text, reenable) {
      if (label) label.textContent = text;
      if (reenable) btn.removeAttribute('disabled');
    };

    btn.setAttribute('disabled', '');
    if (label) label.textContent = 'Adicionando…';

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var sections = drawerSections(drawer);
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || 'add_failed');
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.data);
          if (typeof drawer.open === 'function') drawer.open();
          restore('Adicionado ✓', false);
          setTimeout(function () { restore(prev, true); }, 1400);
        } else {
          window.location = root + 'cart';
        }
      })
      .catch(function (err) {
        restore('Tente de novo', false);
        setTimeout(function () { restore(prev, true); }, 1600);
        if (window.console) console.warn('[ofertas] add falhou:', err && err.message);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-of-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn);
  });
})();
